import { MetaAttributes, UtilityState } from '@/store/modules/utility/state';
import { GetterTree } from 'vuex';
import { RootState } from '@/store/state';

export type Getters<S = UtilityState> = {
  fonts(state: S): string[];
  bodyClassList(state: S): string[];
  userAgent(state: S): string | null;
  host(state: S): string | null;
  path(state: S): string | null;
  cookies(state: S): string | null;
  windowHeight(state: S): number | null;
  campaignPadding(state: S): number | null;
  currentUrl(state: S): string | null;
  metatags(state: S): MetaAttributes[];
};

export interface NamespacedGetters {
  'utility/fonts': string[];
  'utility/bodyClassList': string[];
  'utility/userAgent': string | null;
  'utility/host': string | null;
  'utility/cookies': string | null;
  'utility/path': string | null;
  'utility/windowHeight': number | null;
  'utility/campaignPadding': number | null;
  'utility/currentUrl': string | null;
  'utility/metatags': MetaAttributes[];
}

export const getters: GetterTree<UtilityState, RootState> & Getters = {
  fonts: (state: UtilityState) => {
    return state.fonts;
  },
  bodyClassList: (state: UtilityState) => {
    return state.bodyClassList;
  },
  userAgent: (state: UtilityState) => {
    return state.userAgent;
  },
  host: (state: UtilityState) => {
    return state.host;
  },
  cookies: (state: UtilityState) => {
    return state.cookies;
  },
  path: (state: UtilityState) => {
    return state.path;
  },
  windowHeight: (state: UtilityState) => {
    return state.windowHeight;
  },
  campaignPadding: (state: UtilityState) => {
    return state.campaignPadding;
  },
  currentUrl: (state: UtilityState) => {
    return state.currentUrl;
  },
  metatags: (state: UtilityState) => {
    return state.metatags;
  }
};
